import menuAdministrator from './menu/menuAdministrator';
import menuExecutive from './menu/menuExecutive';
import menuDisbursement from './menu/menuDisbursement';
import menuMesaAprobacion from './menu/menuMesaAprobacion';
import menuroPortfolioAssistant from './menu/menuPortfolioAssistant';
import menuPortfolio from './menu/menuPortfolio';
import menuAprobador from './menu/menuAprobador';
import menuCreditCoordinator from './menu/menuCreditCoordinator';
import menuMesaDeAyuda from './menu/menuMesaDeAyuda';
import menuAliado from './menu/menuAliado';
import menuComercial from './menu/menuComercial';
import menuContabilidad from './menu/menuContabilidad';
import menuHelpDeskCoordinator from './menu/menuHelpDeskCoordinator';
import menuRiskDirector from './menu/menuRiskDirector';
import menuAudit from './menu/menuAudit';
import menuSocialDevelop from './menu/menuSocialDevelop';
import menuSalesRoommanager from './menu/menuSalesRoommanager';
import menuOriginatingExecutive from './menu/menuOriginatingExecutive';
import menuRegionalDirector from './menu/menuRegionalDirector';
import menuZoneDirector from './menu/menuZoneDirector';
import menuManagement from './menu/menuManagement';
import menuArchive from './menu/menuArchive';
import menuDigitalAlly from './menu/menuDigitalAlly';
import menuSupervisor from './menu/menuSupervisor';
import menuHumanManagement from './menu/menuHumanManagement';
import menuOperaciones from './menu/menuOperaciones';
import menuSeguros from './menu/menuSeguros';
import menuFinancialManager from './menu/menuFinancialManager';
import menuOperationsManager from './menu/menuOperationsManager';
import menuMarket from './menu/menuMarket';
import menuAdministrativeDirector from './menu/menuAdministrativeDirector';
import menuLegalAsesor from './menu/menuLegalAsesor';
import menuFinancialAnalyst from './menu/menuFinancialAnalyst';
import menuSupport from './menu/menuSupport';
import menuManagingAlly from './menu/menuManagingAlly';
import menuSalesManager from './menu/menuSalesManager';

export default Object.assign(
    [],
    menuAdministrator,
    menuExecutive,
    menuDisbursement,
    menuMesaAprobacion,
    menuAprobador,
    menuroPortfolioAssistant,
    menuCreditCoordinator,
    menuMesaDeAyuda,
    menuAliado,
    menuComercial,
    menuContabilidad,
    menuHelpDeskCoordinator,
    menuRiskDirector,
    menuAudit,
    menuSocialDevelop,
    menuSalesRoommanager,
    menuPortfolio,
    menuOriginatingExecutive,
    menuRegionalDirector,
    menuZoneDirector,
    menuManagement,
    menuArchive,
    menuDigitalAlly,
    menuSupervisor,
    menuHumanManagement,
    menuOperaciones,
    menuSeguros,
    menuFinancialManager,
    menuOperationsManager,
    menuMarket,
    menuAdministrativeDirector,
    menuLegalAsesor,
    menuFinancialAnalyst,
    menuSupport,
    menuManagingAlly,
    menuSalesManager
);
